module.exports = __webpack_public_path__ + "img/logo-new.18df117b.svg";